const CtaActions = {
  tesco: 'LaunchTescoJourney',
  adobe: 'LaunchAdobeJourney',
  newWindow: 'OpenNewWindow',
  dialogue: 'OpenModalWindow',
  internal: 'OpenUrlInSameTab',
};
export default CtaActions;
